import { replaceWithNonbreakableSpaces, formatPostcode } from '~/utils';

// Local field configurations (migrated from jl-design-system/form/fields)
const ADDRESS_LINE = {
  name: 'addressLine',
  id: 'addressLine',
  type: 'text',
  label: 'Address line',
  required: false,
  maxLength: 35,
  validationMessageKeys: {
    maxLength: 'Please use 35 characters or less',
  },
};

const TOWN_OR_CITY = {
  name: 'townOrCity',
  id: 'townOrCity',
  type: 'text',
  label: 'Town or city',
  required: true,
  maxLength: 35,
  validationMessageKeys: {
    required: 'Please enter a town or city',
    maxLength: 'Please use 35 characters or less',
  },
};

const STATE_OR_COUNTY = {
  name: 'stateOrCounty',
  id: 'stateOrCounty',
  type: 'text',
  label: 'State or county',
  required: false,
  maxLength: 35,
  validationMessageKeys: {
    maxLength: 'Please use 35 characters or less',
  },
};

const POSTCODE_UK = {
  name: 'postcode',
  id: 'postcode',
  type: 'text',
  label: 'Postcode',
  required: true,
  maxLength: 8,
  validationMessageKeys: {
    required: 'Please enter a postcode',
    maxLength: 'Please use 8 characters or less',
  },
};

export const ADDRESS_LINE_TEMPLATE = (index) => ({
  ...ADDRESS_LINE,
  name: `addressLine${index}`,
  id: `addressLine${index}`,
});

export const ADDRESS_FIELDS = [
  {
    ...ADDRESS_LINE,
    label: 'Address',
    required: true,
    validationMessageKeys: {
      ...ADDRESS_LINE.validationMessageKeys,
      required: 'Please enter your address',
    },
  },
  ADDRESS_LINE_TEMPLATE(2),
  {
    ...TOWN_OR_CITY,
    showButtonAbove: true,
  },
  {
    ...STATE_OR_COUNTY,
    label: 'County',
    validationMessageKeys: {
      ...STATE_OR_COUNTY.validationMessageKeys,
      required: 'Please enter a county',
    },
  },
  {
    ...POSTCODE_UK,
    placeholder: 'eg. SW1E 5NN',
    regex: /^[A-Z]{1,2}[0-9R][0-9A-Z]?\s*[0-9][ABD-HJLNP-UW-Z]{2}$/,
    maxLength: 8,
    format: formatPostcode,
    validationMessageKeys: {
      ...POSTCODE_UK.validationMessageKeys,
      regex: `Please enter a valid UK postcode ${replaceWithNonbreakableSpaces('(e.g. SW1E 5NN)')}`,
    },
  },
];
